// extracted by mini-css-extract-plugin
export default {"btn":"BackHome_btn__BaGzZ"};